import type { ComponentType, SVGProps } from 'react';

interface Props {
  label: string;
  value: number | string;
  hint?: string;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  tone?: 'default' | 'positive' | 'warning' | 'danger';
}

const TONE: Record<NonNullable<Props['tone']>, string> = {
  default: 'text-zinc-300',
  positive: 'text-emerald-300',
  warning: 'text-amber-300',
  danger: 'text-rose-300',
};

export function StatCard({ label, value, hint, icon: Icon, tone = 'default' }: Props) {
  return (
    <div className="card p-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-[var(--color-text-faint)]">
          {label}
        </span>
        {Icon && (
          <Icon className="text-[var(--color-text-faint)]" width={14} height={14} />
        )}
      </div>
      <div className={`mt-2 text-2xl font-semibold tabular-nums ${TONE[tone]}`}>
        {value}
      </div>
      {hint && (
        <div className="mt-1 text-xs text-[var(--color-text-faint)]">{hint}</div>
      )}
    </div>
  );
}
